import styled from 'styled-components/macro'

import { Box } from '~components/atoms/box'

export const StyledGroup = styled(Box)``
